import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    const loc = useLocation();
    if (user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="loading">
                Loading…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    // Non-Richards-Bay terminals only expose a Coming-Soon splash for now.
    const activeTerminal = user.active_terminal || user.terminal;
    if (activeTerminal && activeTerminal !== "richards_bay" && !loc.pathname.startsWith("/coming-soon")) {
        return <Navigate to="/coming-soon" replace />;
    }
    // FEL operators are sandboxed to /fel
    if (user.role === "fel_operator" && !loc.pathname.startsWith("/fel")) {
        return <Navigate to="/fel" replace />;
    }
    // Clients are sandboxed to /client — they only ever see their stockpile
    // and allocated vessels, nothing else.
    if (user.role === "client" && !loc.pathname.startsWith("/client")) {
        return <Navigate to="/client" replace />;
    }
    if (roles && !roles.includes(user.role))
        return <Navigate to="/portal" replace />;
    return children;
}
